import { Button } from "app/components/button";
import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { Table } from "app/components/table";
import { useEmpresa, useResourcesContext } from "app/contexts";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export function EncargadosTable() {
  const navigate = useNavigate();

  const { getCargos, getGenero } = useResourcesContext();
  const { empresa, deleteEncargado } = useEmpresa();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Encargados (requerido)</strong>
            </h5>

            <AddLink to="add" title="Agregar encargado" />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.encargados.length ? (
            <Table
              titles={["#", "Datos personales", "Cargo(s)", "Opciones"]}
              responsive
            >
              {empresa.encargados.map((encargado, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td>
                    <div>
                      <b>Género: </b>
                      {getGenero(encargado.genero_id)}
                      <br />
                      <b>Nombre: </b>
                      {encargado.encargado_nombre_completo}
                      <br />
                      <b>DNI: </b> {encargado.encargado_identificacion} <br />
                      <b>RTN: </b> {encargado.encargado_rtn} <br />
                      <b>Teléfono: </b>
                      {encargado.encargado_telefono || "N/D"} <br />
                      <b>Celular: </b>
                      {encargado.encargado_celular || "N/D"} <br />
                      <b>Correo electrónico: </b>
                      {encargado.encargado_correo_electronico || "N/D"} <br />
                    </div>
                  </td>

                  <td>{getCargos(encargado.cargos)}</td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => deleteEncargado(i)}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Por favor, agregue al menos un encargado.
            </p>
          )}
        </Column>
      </Row>

      <DFlexResponsive justifyContent="end">
        <Button
          title="Anterior"
          color="secondary"
          onClick={() => navigate("../../contactos")}
        />

        <Button
          title="Siguiente"
          color="success"
          onClick={() => {
            if (!empresa.encargados.length) {
              toast.error("Por favor, agregue al menos un encargado.");

              return navigate("add");
            }

            return navigate("../../actividad-economica");
          }}
        />
      </DFlexResponsive>
    </Container>
  );
}
